export const TIME = 'hh:mm a';
export const MMMM_DD_YYYY_HH_MM_A = 'MMMM DD,YYYY - hh:mm a';
export const MMMM_DD_YYYY = 'MMMM DD,YYYY';
